<ng-template #cellTemplate let-column='column' let-element='element' let-index='index' let-value='value' let-tooltip='tooltip'>
  @switch (column.fieldView || (column.fieldDefinition && column.fieldDefinition.fieldView)) {
    @case (fieldViewType.CUSTOM_ICON) {
      @if (tooltip) {
        <i [matTooltip]='tooltip' [class]='value'></i>
      }
      @if (!tooltip) {
        <i [class]='value'></i>
      }
    }
    @case (fieldViewType.HTML) {
      @if (tooltip) {
        <span [matTooltip]='tooltip' [innerHtml]='value | safeHtml' (click)='column.onClick && column.onClick(element, datasetACS, datasetNavigatorService);$event.preventDefault();$event.stopPropagation()'></span>
      }
      @if (!tooltip) {
        <span [innerHtml]='value | safeHtml' (click)='column.onClick && column.onClick(element, datasetACS, datasetNavigatorService);$event.preventDefault();$event.stopPropagation()'></span>
      }
    }
    @case (fieldViewType.MIXED_COLUMN) {
      @if (tableValues[element.id] && tableValues[element.id][column.key + "-cell-configs"]) {
        @for (cellConfig of tableValues[element.id][column.key + '-cell-configs']; track cellConfig; let cellIndex = $index) {
          <ng-container
            [ngTemplateOutlet]='cellTemplate'
            [ngTemplateOutletContext]='{column:cellConfig, element:element, index:i, value: tableValues[element.id] && tableValues[element.id][column.key], tooltip: tableValues[element.id] && tableValues[element.id][column.key + "-mat-tooltip"]}'
          ></ng-container>
        }
      }
    }
    @case (fieldViewType.BUTTON) {
      @if (column.actionButton) {
        <ng-container
          [ngTemplateOutlet]='actionButtonTemplate'
          [ngTemplateOutletContext]='{action:column.actionButton, element:element}'
        ></ng-container>
      }
    }
    @case (fieldViewType.IMAGE) {
      @if (value && !column.fieldDefinition.resize) {
        <img class="package-img" [src]='appService.getBaseServerAddressRoot() + "/document_files/download/" + value'/>
      }
      @if (value && column.fieldDefinition.resize) {
        <img class="package-img" [src]='appService.getBaseServerAddressRoot() + "/document_files/resize/" + column.fieldDefinition.resize.width + "x" + column.fieldDefinition.resize.height + "/" + value'/>
      }
      @if (!value) {
        <span>{{'Nessuna immagine' | translate}}</span>
      }
    }
    @case (fieldViewType.BG_IMAGE) {
      @if (value) {
        <div class="package-bg-img" [style.background-image]='"url(" + appService.getBaseServerAddressRoot() + "/document_files/download/" + value + ")"'></div>
      }
      @if (!value) {
        <span>{{'Nessuna immagine' | translate}}</span>
      }
    }
    @case (fieldViewType.DIALOG_TEXT) {
      @if (value && column.fieldDefinition.prefixIcon) {
        <button mat-icon-button (click)='openTextDialog(value, column.fieldDefinition.name)'>
          @if (column.fieldDefinition.prefixIcon) {
            <mat-icon>{{column.fieldDefinition.prefixIcon}}</mat-icon>
          }
        </button>
      }
      @if (value && !column.fieldDefinition.prefixIcon) {
        <button mat-flat-button (click)='openTextDialog(value, column.fieldDefinition.name)'>
          <span>{{column.fieldDefinition.name | translate}}</span>
        </button>
      }
    }
    @case (fieldViewType.MENU) {
      @if (column.menu && column.menu.items && column.menu.icon) {
        <button mat-icon-button [matMenuTriggerFor]='menu'>
          <mat-icon>{{column.menu.icon}}</mat-icon>
        </button>
      }
      @if (column.menu && column.menu.items && !column.menu.icon && column.menu.text) {
        <button mat-stroked-button [matMenuTriggerFor]='menu'>
          <span>{{column.menu.text | translate}}</span>
        </button>
      }
      <mat-menu #menu='matMenu'>
        @for (item of column.menu.items; track item) {
          @if (!item.showIf || item.showIf(element, datasetACS)) {
            @if (!item.makeLink) {
              <button mat-menu-item (click)='item.onClick && item.onClick(element, datasetACS, datasetNavigatorService)'>
                @if (item.icon) {
                  <mat-icon>{{item.icon}}</mat-icon>
                }
                @if (item.text) {
                  <span>{{item.text | translate}}</span>
                }
              </button>
            }
            @if (item.makeLink) {
              <a mat-menu-item [href]='item.makeLink(element)' target="_blank">
                @if (item.icon) {
                  <mat-icon>{{item.icon}}</mat-icon>
                }
                @if (item.text) {
                  <span>{{item.text | translate}}</span>
                }
              </a>
            }
          }
        }
      </mat-menu>
    }
    @default {
      @if (tooltip) {
        <span [matTooltip]='tooltip'>{{value}}</span>
      }
      @if (!tooltip) {
        <span>{{value}}</span>
      }
    }
  }
</ng-template>

<ng-template #actionButtonTemplate let-action='action' let-element='element'>
  @if (!action.routerLink && action.onClick) {
    @if (!action.buttonText && action.buttonIcon) {
      <button (click)='action.onClick($event, element, datasetACS, datasetNavigatorService)' [matTooltip]='action.tooltip | translate' mat-icon-button [color]='action.buttonColor'>
        <mat-icon>{{action.buttonIcon}}</mat-icon>
      </button>
    }
    @if (action.buttonText && !action.buttonIcon) {
      <button (click)='action.onClick($event, element, datasetACS, datasetNavigatorService)' [matTooltip]='action.tooltip | translate' mat-flat-button [color]='action.buttonColor'>
        {{action.buttonText | translate}}
      </button>
    }
    @if (action.buttonText && action.buttonIcon) {
      <button (click)='action.onClick($event, element, datasetACS, datasetNavigatorService)' [matTooltip]='action.tooltip | translate' mat-flat-button [color]='action.buttonColor'>
        <mat-icon>{{action.buttonIcon}}</mat-icon>
        <span>{{action.buttonText | translate}}</span>
      </button>
    }
  }
  @if (action.routerLink) {
    @if (!action.buttonText && action.buttonIcon) {
      <a [routerLink]='action.routerLink' [queryParams]='action.queryParams' [matTooltip]='action.tooltip | translate' mat-icon-button [color]='action.buttonColor'>
        <mat-icon>{{action.buttonIcon}}</mat-icon>
      </a>
    }
    @if (action.buttonText && !action.buttonIcon) {
      <a [routerLink]='action.routerLink' [queryParams]='action.queryParams' [matTooltip]='action.tooltip | translate' mat-flat-button [color]='action.buttonColor'>
        {{action.buttonText | translate}}
      </a>
    }
  }
  @if (!action.routerLink && !action.onClick) {
    @if (!action.buttonText && action.buttonIcon) {
      <button [matTooltip]='action.tooltip | translate' mat-icon-button [color]='action.buttonColor'>
        <mat-icon>{{action.buttonIcon}}</mat-icon>
      </button>
    }
    @if (action.buttonText && !action.buttonIcon) {
      <button [matTooltip]='action.tooltip | translate' mat-flat-button [color]='action.buttonColor'>
        {{action.buttonText | translate}}
      </button>
    }
  }
</ng-template>

<mat-card [class.mat-elevation-z0]='!elevate' class='no-card-box' [ngClass]='tableStyle || viewConfig?.tableStyle'>
  <mat-card-content>
    @if (showHeaderToolbar) {
      <dataset-filter
        [loading]='datasetACS.loading.value'
        [actionButtons]='globalActionButtons'
        [showSearchText]='showSearchBar && viewConfig.showSearchBar'
        [filtersData]='filtersData'
        (filterChange)='filterChange.emit($event)'
        [formConfig]="filterForm"
        [dataContainerService]='datasetACS'
        [filterStyle]='filterStyle || viewConfig?.filterStyle'
      ></dataset-filter>
    }
    @if (!showHeaderToolbar && datasetACS.loading.value) {
      <mat-progress-bar mode='indeterminate'></mat-progress-bar>
    }

    <div class="custom-table-responsive">
      @if (!datasetACS.loading.value && paginationResponse) {
        <table mat-table [dataSource]="paginationResponse.items" [ngClass]='tableStyle || viewConfig?.tableStyle'>
          <!-- Generic column definition -->
          @for (column of viewConfig.columns; track column) {
            <ng-container [matColumnDef]="column.key">
              <th mat-header-cell *matHeaderCellDef [width]='column.width||""'> {{column.title | translate | titlecase}} </th>
              <td [ngStyle]='column.style' [attr.data-label]='column.title | translate' mat-cell *matCellDef="let element; let i = index;">
                @if (!selectable && (column.onClick || column.routerLink) && (column.actionCode === "noaction" || (tableValues[element.id] && tableValues[element.id].allowed_actions[column.actionCode || "view_detail"]))) {
                  @if (column.onClick) {
                    <a
                      style='cursor: pointer;'
                      (click)='column.onClick(element, datasetACS, datasetNavigatorService)'>
                      <ng-container
                        [ngTemplateOutlet]='cellTemplate'
                        [ngTemplateOutletContext]='{column:column, element:element, index:i, value: tableValues[element.id] && tableValues[element.id][column.key], tooltip: tableValues[element.id] && tableValues[element.id][column.key + "-mat-tooltip"]}'
                      ></ng-container>
                    </a>
                  }
                  @if (column.routerLink) {
                    <a
                      [routerLink]="column.routerLink(element)">
                      <ng-container
                        [ngTemplateOutlet]='cellTemplate'
                        [ngTemplateOutletContext]='{column:column, element:element, index:i, value: tableValues[element.id] && tableValues[element.id][column.key], tooltip: tableValues[element.id] && tableValues[element.id][column.key + "-mat-tooltip"]}'
                      ></ng-container>
                    </a>
                  }
                } @else {
                  <ng-container
                    [ngTemplateOutlet]='cellTemplate'
                    [ngTemplateOutletContext]='{column:column, element:element, index:i, value: tableValues[element.id] && tableValues[element.id][column.key], tooltip: tableValues[element.id] && tableValues[element.id][column.key + "-mat-tooltip"]}'
                  ></ng-container>
                }
              </td>
            </ng-container>
          }
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> {{selectable?"Seleziona":"Azioni" | translate}} </th>
            <td class="actions-column" mat-cell *matCellDef="let element; let i = index;">
              @if (!selectable) {
                <div>
                  @if (tableValues[element.id]) {
                    @for (action of tableValues[element.id]["_column_actions"]; track action) {
                      <ng-container
                        [ngTemplateOutlet]='actionButtonTemplate'
                        [ngTemplateOutletContext]='{action:action, element:element, index:i}'
                      ></ng-container>
                    }
                  }
                </div>
              }
              @if (selectable) {
                <div>
                  <!-- if dataset model return selectable property -->
                  @if (element && element.hasOwnProperty('selectable')) {
                    @if (element.selectable) {
                      <button mat-flat-button color='accent' (click)='select(element)'>
                        @if (selectionBtnIcon) {
                          <span class="material-icons-outlined btn-icon">{{ selectionBtnIcon }}</span>
                        }
                        @if (selectionBtnTxt) {
                          <span class="btn-txt" [innerHtml]='selectionBtnTxt | translate'></span>
                        }
                      </button>
                    }
                    @if (!element.selectable) {
                      <button [disabled]='!element.selectable' mat-flat-button color='primary'>
                        <span class="btn-txt">{{'Non selezionabile' | translate}}</span>
                      </button>
                    }
                  }
                  <!-- if selectable enabled from dataset input property -->
                  @if (element && !element.hasOwnProperty('selectable')) {
                    <button mat-flat-button color='accent' (click)='select(element)'>
                      @if (selectionBtnIcon) {
                        <span class="material-icons-outlined btn-icon">{{ selectionBtnIcon }}</span>
                      }
                      @if (selectionBtnTxt) {
                        <span class="btn-txt" [innerHtml]='selectionBtnTxt | translate'></span>
                      }
                    </button>
                  }
                </div>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef="massselect">
            <th mat-header-cell *matHeaderCellDef>
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="isAllMassiveSelected"
                [indeterminate]="massSelection.size>0 && !isAllMassiveSelected">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element; let i = index;">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? toggleRow(tableValues[element.id]) : null"
                [checked]="massSelection.has(tableValues[element.id].record.id)">
              </mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="mass-selection-description">
            <td mat-footer-cell *matFooterCellDef [colSpan]="displayedColumns.length - 1">
              <span class='ml-4'>{{massSelection.size}} {{'elementi selezionati' | translate}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="mass-actions">
            <td mat-footer-cell *matFooterCellDef>
              @for (action of massActionButtons; track action) {
                <button mat-icon-button [matTooltip]='action.tooltip' [color]='action.buttonColor' (click)='clickMassAction(action)'>
                  <mat-icon>{{action.buttonIcon}}</mat-icon>
                </button>
              }
            </td>
          </ng-container>
          <ng-container matColumnDef='riepilogo'>
            <td mat-footer-cell *matFooterCellDef [colSpan]='displayedColumns.length'>
              @for (metaReview of viewConfig.metaReviews; track metaReview) {
                <div class="inner_footer_review" [innerHTML]='viewConfig.getMetaReview(paginationResponse, metaReview)'></div>
              }
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"
            [class.deleted-row]='tableValues[row.id] && tableValues[row.id].isDeleted'
            [class.is-new-row]='tableValues[row.id] && tableValues[row.id].isNewRow'
            [class.status-active-bar-mobile]="row.active_status && !row.publish_on_web"
            [class.status-active-published-bar-mobile]="row.active_status && row.publish_on_web"
            [class.status-disabled-bar-mobile]="!row.active_status && !row.publish_on_web || !row.active_status && row.publish_on_web"
          ></tr>
          <tr mat-footer-row
            [hidden]='massSelection.size === 0'
            *matFooterRowDef="['mass-selection-description', 'mass-actions']; sticky: true; when: "
            class='grey-200'
          ></tr>
          <!-- riepilogo totali -->
          <tr mat-footer-row
            [hidden]='paginationResponse && !viewConfig.metaReviews'
            *matFooterRowDef="['riepilogo']; sticky: true;"
            class='grey-200'
          ></tr>
        </table>
      }
    </div>
    @if (!datasetACS.loading.value && paginationResponse && paginationResponse.items && paginationResponse.items.length == 0) {
      <div>
        <p class='pl-16'>{{'Nessun elemento presente' | translate}}</p>
      </div>
    }
  </mat-card-content>
  @if (canCreate || hasGlobalButtons || showPaginationComponent) {
    <mat-card-footer>
      <mat-toolbar>
        <span class="fx-flex"></span>
        @if (showPaginationComponent) {
          <mat-paginator
            [pageSizeOptions]="[5, 10, 20, 50, 100, 200]"
            showFirstLastButtons
            [class.hide-last-page-button]='totalCapped'
            [length]="paginationResponse.meta.total"
            [pageSize]="paginationResponse.meta.perPage"
            (page)="onPaginatorChange($event)">
          </mat-paginator>
        }
      </mat-toolbar>
    </mat-card-footer>
  }
</mat-card>
